module.exports = __webpack_public_path__ + "static/media/adobe.b79076c9.svg";